import { BadRequestError } from "./errors.types";

/** The most sections a learner can have recommended in one course at a time. */
export const MAX_RECOMMENDED_SECTIONS = 5;

export type RecommendedSectionInput = {
	/** The Sanity `_key` of a section or sub-section of the course */
	sectionKey: string;
	/** Why the learner should study it, written to the learner */
	rationale: string;
};

export type SetRecommendedSectionsInput = {
	userId: string;
	/** The Sanity `_id` of the course */
	courseId: string;
	/** The tutor thread making the recommendation */
	sourceThreadId?: number;
	/** The sections to recommend, most important first; empty to clear */
	sections: RecommendedSectionInput[];
};

export type GetRecommendedSectionsInput = {
	userId: string;
	/** The Sanity `_id` of the course */
	courseId: string;
};

/** A section or sub-section of a course that a recommendation can point at. */
export type RecommendableSection = {
	key: string;
	title: string;
	/** The title of the section it sits under; null for a top-level section */
	parentTitle: string | null;
};

/**
 * Thrown when a recommendation names a key the course does not have. It carries every key the course does have, so the caller (the tutor) can pick again.
 */
export class UnknownSectionKeysError extends BadRequestError {
	public readonly unknownKeys: string[];
	public readonly validSections: RecommendableSection[];

	constructor(unknownKeys: string[], validSections: RecommendableSection[]) {
		super(`Not sections of this course: ${unknownKeys.join(", ")}`);
		this.unknownKeys = unknownKeys;
		this.validSections = validSections;
	}
}
